import React from "react";
import { FontStyles } from "../../utils/font-styles.ts";

interface DividerProps {
  message?: string;
}

const parentContainerStyle = "flex items-center w-full justify-center gap-x-3";
const messageStyle = "text-light-slate font-normal text-nowrap " + FontStyles["body-md"];
const lineStyle = "h-px border-t-0 bg-neutral-200 w-full";

export const Divider: React.FC<DividerProps> = ({ message }) => {
  if (message) {
    return (
      <div className={parentContainerStyle}>
        <hr className={lineStyle + " max-w-16"} />
        <span className={messageStyle}>{message}</span>
        <hr className={lineStyle + " max-w-16"} />
      </div>
    );
  } else {
    return (
      <div className={parentContainerStyle}>
        <hr className={lineStyle} />
      </div>
    );
  }
};
